import Styles from "./custom_legend.module.scss";

export type CustomLegendKey = {
  legendLabel: string;
  color: string;
  [key: string]: unknown;
};

export function CustomLegend({ keys }: { keys: CustomLegendKey[] }) {
  return (
    <div className={Styles.customLegendContainer}>
      {keys.map((chartKey) => {
        return (
          <div key={chartKey.legendLabel} className={Styles.customLegendItem}>
            <div className={Styles.customLegendItemContent}>
              <div
                style={{
                  width: "var(--spacing-150)",
                  height: "var(--spacing-150)",
                  borderRadius: "50%",
                  backgroundColor: chartKey.color,
                }}
              ></div>
              <div className={Styles.customLegendItemLabel}>{chartKey.legendLabel}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
